export default "__VITE_ASSET__c7bfb67b__"